// DS1.14
import React from 'react';
import classnames from 'classnames';
import s from './ProgressBar.scss';

interface Props {
  /**
   * A float value between 0 and 1. We multiply it by 100 for display.
   */
  progress: number;
  hasError?: boolean;
  className?: string;
}

const ProgressBar: React.FC<Props> = ({ progress, hasError, className }) => (
  <div className={classnames(s['root'], hasError && s['error'], className)}>
    <div
      style={{
        width: hasError
          ? 30
          : `${Math.max(Math.min(Math.round(progress * 100), 100), 0)}%`,
      }}
      className={s['bar']}
    />
    <div className={s['border-top']} />
    <div className={s['border-bottom']} />
    <div className={s['border-left']} />
    <div className={s['border-right']} />
  </div>
);
ProgressBar.displayName = 'ProgressBar';

export default ProgressBar;
